import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../hoc/Auxilliary";
import CourseCatalog from "../../components/CourseCatalog";

const CoursePage = (props) => {
  return (
    <Aux>
      <Grid container>
        <Grid item container xs={12} sm={10} style={{ margin: "0 auto" }}>
          <CourseCatalog />
        </Grid>
      </Grid>
    </Aux>
  );
};

export default CoursePage;
